import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { etherealBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Radiant / Hallowed Expanse — divine sacred light: a luminous gold-and-white sky, a brilliant
 *  overhead sun + broad halo, soft holy cloud bands, slow floating golden light-motes, brilliant
 *  god-ray shafts streaming from above, a swelling radiant glow-bed, a luminous light field, gentle
 *  ascending motes of light, a soft ground shimmer, lit golden temple colonnades, and a warm gold
 *  grade. The serene, uplifting LIGHT counterpoint to the Corrupted void — ethereal WARMTH kept
 *  gold (a 'normal' grade so it never washes pale-white). */
export const RADIANT = etherealBiome({
  id: 'radiant',
  sky: { from: 0x8aa9dd, to: 0xffe2a0 },
  celestial: { atX: 0.5, atY: 0.14, color: P.sunHaze, haloColor: 0xffe6a0, size: 110, haloScale: 3.4, coreAlpha: 0.9, haloAlpha: 0.26 },
  cloudBands: { count: 5, color: 0xfff3d8, sizeMin: 400, sizeMax: 720, alphaMin: 0.05, alphaMax: 0.13, driftPxPerSec: 5, bandYMin: 0.07, bandYMax: 0.3 },
  motes: { colors: [P.firefly, P.sunHaze, 0xffd86b], sizeMin: 5, sizeMax: 14, driftPx: 30, periodMinMs: 7000, periodMaxMs: 14000, alphaMin: 0.2, alphaMax: 0.7 },
  rays: { color: P.sunHaze, count: 5, widthMin: 80, widthMax: 180, height: 580, tiltDeg: 6, periodMinMs: 8000, periodMaxMs: 15000, alphaMin: 0.14, alphaMax: 0.42 },
  glow: {
    blobs: [
      { color: P.sunHaze, atX: 0.5, atY: 0.14, size: 460, alpha: 0.1 },
      { color: 0xffd86b, atX: 0.5, atY: 0.96, size: 600, alpha: 0.09 },
    ],
    breathe: { periodMs: 5800, min: 0.8, max: 1.3 },
  },
  lightField: { palette: [P.sunHaze, P.firefly, 0xffd86b], count: 14, sizeMin: 120, sizeMax: 300, alphaMin: 0.05, alphaMax: 0.16, driftRadius: 64, periodMinMs: 7000, periodMaxMs: 13000 },
  weather: { mode: 'rise', color: P.firefly, colorEnd: 0xfff6e0,
    size: 8, frequencyMs: 120, lifespanMs: 4600, speed: 16, gravityY: -10, windX: 12, alphaEnd: 0.5,
    gust: { periodMs: 7500, min: 0.5, max: 1.45, phase: 0.3 } },
  flicker: { color: 0xfff0c8, size: 300, baseAlpha: 0.06, flickerAmp: 0.04, hzMin: 2, hzMax: 5, anchors: [{ atX: 0.25, atY: 0.92 }, { atX: 0.55, atY: 0.95 }, { atX: 0.82, atY: 0.92 }] },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.celestial.far, shape: 'columns', color: 0xc9a85e, speed: 0.04, height: 380, alpha: 0.7, detail: 0.7, sway: { ampPx: 8, periodMs: 30000 } },
    { svg: OTHERWORLD_BACKDROPS.celestial.mid, shape: 'columns', color: 0xb08a44, speed: 0.10, height: 270, alpha: 0.84, detail: 1.0 },
    { svg: OTHERWORLD_BACKDROPS.celestial.near, shape: 'columns', color: 0x8f6c30, speed: 0.18, height: 170, alpha: 0.94, detail: 1.1 },
  ],
  closer: {
    vignette: { color: 0x5a4a22, edgeAlpha: 0.2, washColor: 0xffd86b, washAlpha: 0.05 },
    grade: { top: 0xffe6a0, bottom: 0xd9a850, strength: 0.1, blend: 'normal' },
  },
});
